import axios from 'axios'
import store from '@/store'
import router from '@/router'
import Vue from 'vue';
import { PANEL, APP_VERSION_MISMATCH } from '@/constants';
import { version } from '../../package.json';

export default (options = {}) => {
  // Init Axios
  const config = {
    baseURL: process.env.VUE_APP_SERVERURL
  }

  if (store.state.user.token) {
    config.headers = {
      Authorization: `Bearer ${store.state.user.token}`,
      panel: PANEL.toLowerCase(),
      appversion: version,
    }
  }

  const axiosInstance = axios.create(config)

  // Add interceptors
  axiosInstance.interceptors.request.use(request => requestHandler(request))

  axiosInstance.interceptors.response.use(
    response => successHandler(response),
    error => errorHandler(error)

  )

  const isHandlerEnabled = (config = {}) => {
    return !(Object.prototype.hasOwnProperty.call(config, 'bar') && !config.handlerEnabled)
  }

  const requestHandler = request => {
    if (request.method === 'get' || options.displayLoader) {
      store.dispatch('user/setLoader', true)
    }

    if (request.data) {
      delete request.data.createdBy
      delete request.data.updatedBy
      delete request.data.createdAt
      delete request.data.updatedAt
    }

    return request
  }

  const errorHandler = error => {
    if (error.response && isHandlerEnabled(error.config)) {
      if (error.response.status >= 500 && error.response.status <= 599) {
        store.dispatch('user/setSnack', error.response.data.error || 'Server Error! Oops, Something went wrong.')
      } else if (error.response.status === 401) {
        store.dispatch('user/setUser', null)
        store.dispatch('user/setToken', null)
        store.dispatch('user/setSnack', 'Sorry, your session has expired. Please login again.')
        store.dispatch('user/setLoader', false)
        router.push('/login')
      } else if (error.response.status === 422 && error.response.data.error === APP_VERSION_MISMATCH) {
        Vue.prototype.$bus.$emit('appversion');
      } else if (
        error.response.status >= 400 &&
        error.response.status <= 499 &&
        error.response.data.error
      ) {
        store.dispatch('user/setSnack', error.response.data.error)
      } else {
        store.dispatch('user/setSnack', 'Something went wrong! try again.')
      }
      store.dispatch('user/setType', 'error')
    }
    store.dispatch('user/setLoader', false)
    return Promise.resolve(false)
  }

  const successHandler = response => {
    if (response && response.data && response.data.message && !options.hideSuccessMessage) {
      store.dispatch('user/setSnack', response.data.message)
      store.dispatch('user/setType', 'info')
    }
    store.dispatch('user/setLoader', false)
    return response
  }

  return axiosInstance
}
